import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ListPage from "./ListPage";
import Step1Name from "./create/Step1Name";
import Step2Upload from "./create/Step2Upload";
import Step3Generate from "./create/Step3Generate";
import Step4Editor from "./create/Step4Editor";

export default function DesignBackground() {
  return (
    <Routes>
      <Route path="/" element={<ListPage />} />
      <Route path="/create/step1" element={<Step1Name />} />
      <Route path="/create/step2" element={<Step2Upload />} />
      <Route path="/create/step3" element={<Step3Generate />} />
      <Route path="/edit/:id" element={<Step4Editor />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
